<template>
  <header id="header_main" class="header header-fixed">
    <div class="header-top">
      <div class="left">
        <div class="wg-information">
          <div class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="13"
              height="16"
              viewBox="0 0 13 16"
            >
              <image
                id="_"
                data-name=""
                width="13"
                height="16"
                xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAgCAYAAAAMq2gFAAADaUlEQVRIia2We29UVRTFfx0uCC3TFtoCxUJRgwISCIjGQEz8xxg/l1/HT4CJPEQwCAIFlTdKQCmP1nagUx5TyE5+x1xO7p1pE3dy00nnzF577bX2Prfv9Hff0iUawGpgDTAADAJN//ccaAFzwDPgFfCiLlXRDcWkI8BG/24A1gsUSeeBx8CMfx9bwLKBgsk48BGwH9gNTAoc7PqAJcEeAXeAi8AF4FoVWBXQOmAb8CnwiUC7gK01RQXYXWACGJPxddnVAq0FdgJfAF8DH9uyobreyvA99dtmJ44BZ4AnVUANqz4CfAMcVpPlxCpgk+f7bW3oN6VhOmWgYWAf8BXw+QpAyhEm+VCNZnXiFeBpIZOg/z5wUE1GKpK0bEXLBGs9NyKjFO/Y/sOe/zt0LGzfiAAHbEEe81YWzroNtBU+OnAI2J6dD0336MZfY84So2GdtVP6KTpBW8seB05lQFHtS5+tOjbFmCMRhT9MjJrac0LqKRaBWwJ8r7jztu6RnxcF+tLfpwjQUZ+hQpcM2r6BCl2uAmdt3Uzpu7ZFYPX7MyDMHaba0BBk2EHLY8H23Bc0j9gOD2XXrvh+jd0aTEtztVrVxWuflcZ/+RuukAUrypP1K/KEzPNoKPZYZoQUr5yp54WumtPzz7IWNnXjtN//VroSoi1bgM8ci6oBbzu4s4VsIslfarGj5LwYyg9KTDcD93TaoLNyxEHPh7xtgZFzupBabNrfnaPxEtAqh2+Xn8czoFg3e4F33W8pOprohudnCmfgiVM/aZW5HgPeTVuy1g3p2L7sfIzBJeB8cmxhWxZdF1OulE3qU451NYLn0ZHFWcFCoxdlS/9r+352OKvmpldE0Q+Ay8AvwM3k5vI1EcP3D/CTrRutYNUrWoKc9pZ9ms7nN+yc936/18boCu+lO6XlO13+It8GSwo55VV8TbP0io7duKA2t/Lf1b0FhTV/dOLHdWO3mFGTU7ZsMT9bt99eyuaM7Ga77LolLRzanss2fE8gTB7uO+EtOVdxJrlsSkY3arZ4zzfVBzqo6fppZu8HLYs4KchCXaJeQC1ZrXfnbVSztAliTo4CP+QuWylQAvtDoTe7dmLZRuJgG0/YumssBygiWhhAsZpitoJhGCXeI9J1/r8AxRKNKzt0iMkPoDDAn3XivxXAG/709S6pPU+LAAAAAElFTkSuQmCC"
              />
            </svg>
          </div>
          <div class="content">
            <p class="tf-color">{{ contact.address }}</p>
          </div>
        </div>
        <div class="wg-information">
          <div class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="17"
              height="13"
              viewBox="0 0 17 13"
            >
              <image
                id="_"
                data-name=""
                width="17"
                height="13"
                xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAaCAYAAADSbo4CAAADAElEQVRIic2WWWtTQRiGnzSnaWtbbN2tW4tYUay4XKgg6m/wL/lPvPY3eFkv3FBRUEFRbF3q1s1qkjbyhWdgCF0Sl+oHQybnnHnnnffbpjR54xqZFcBWYAewGxgASsA3YA6YAb4AXb4fAbYBPcCKI7eS82q2/oPzH/n3RcuiIDEGjAJ7gcGMyDwwDbwBvgJliR6WVN2RWxBuADU3/yjGlGOulUjJjU8Dl4GTgld8XxfsPfAQmARe+34COC9GqyLJVlTlu4rcB24CD1S4SaQf2C7YFeAicDQjkVuQOaArJv1dBno9SLEGkdziUPuAPqAbuBNqx8Jxx1XgHLBnDRK4cNx5uO058AzYAlxy7UYWex5TgF5VehEPzzhCiZE2gHoyxeoqE2AH2ySCBMaNvVeBGUQuAKeUtl2rGNQvgdsG8pxuKneAM+r+fUmmMYOtKuiSoMkavq/ohgHnO4FdwIKnW9BlDVVaNE2RYBo9xsgWg71UKOewH8/r92mBUh2om4rDnmJMoH6JNCTxWdkbZkdk1ifJlCTRp/qR9kO6dLbwZGnDJfP7qcDpeU2QETfPo37Yb4P4rCrhfEoyM7quqppnLIRDqtNbZJv9ihUCFar23d+UxmWVjAL42GI46OHPZjj1oqUa9nna0jqu2akSydI3DeNqRSJx2kNihsvvqhDG5WK2rlo4SRZsjwD7NwjWSva8sQqRbgkPWgCXraKPVqm+jSRtTqRilW3XciK5i8vGUr//T1inagbuhH2NRL6dkvwnbLc97KAbH8qKX3UziUScHDdl0/9e5/XNJNLtGFzlXdO1XZtEZEP7r4h00qT+Foeurpb0/RfWLAG/S2Qgy4DUBFcLyPUsgrgcRN7ll9gOrW5dWM4uz7UOMaJjf470vWWHjLKe0nkjlVIVjd7xBHirOjUbXLpWrIWT1jevidEMY+Prltu4V4TE693GW4Gi/ce9I5paYN2zvYeb1iOSQiKuHeGR5n0kLkLRyOJ0nRKJ8hxdNH7D4t4RWKk7t0NkFlj6CW2ly+DSZ9BoAAAAAElFTkSuQmCC"
              />
            </svg>
          </div>
          <div class="content">
            <p class="tf-color">{{ $t("email_contact") }}</p>
            <p>{{ contact.shop_email }}</p>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="wg-information">
          <div class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="17"
              height="15"
              viewBox="0 0 17 15"
            >
              <image
                id="_"
                data-name=""
                width="17"
                height="15"
                xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAAEFklEQVRYhbWXW2+UVRSGn6nTOqXnQk/WUFEpghIrFYmNh6gx3viv/DHeGK+81HiIEEXRKIkoRqFNtXUsWhjAocxYs+qzze7XmXYa05Xs5Jt9WOtdh3ftPaUL77zFHtIFlB3dQC8w4KgAJY9vAnWg5vgLuA80HH/vZqa8FwqgDxgGhoB+vwf3AHILWAduAzf9rv0fIEeAJ4CTwGPAw8CE4LpbnG8YhTvAb8Ay8BNwBfgeWNsPkPB8HJgEHgGecpwAjgqgEwlAS8APwOPAMeA6sApUjVRbIBHueeA54LSGA9BhYKRDAEm6jeIoMAssCOwycBH4Ik9XAOkx1xHySMHLwDngVGa8oRd/mvcNPa6bBkxXRQA91tOIQEaMSpyfAcZcv2IK62UnIvevAS8ZiQnnsQgXgW/M8wpwV1bUshAPGdFg1SFgyvp6GnjUoh7x96RznwAfRC2VZUAAeQF41d9kkQgQF4D3ge+MQDkrytvu7c+KuOH3qSxiM57rd4xJ6aihW2XDGd48VACBNIwofA58JQ3H9LY7YwkZi+4btVVTN5ClZzTTPajNsF0p27B6WoBAw98CV/UwmHPcIq64J+8jaDyK8kfpG2enbQGjBf2D2u4KIPc8HAVYlCULKrx8EXjFNA7ofakAZNMo1QTxIfClOpasi1w2tH2vnB06bxF2mbsN56oWV7Dp9X30kZPqWVbHeed7Mhtfu14rW/URxreBj9y44ajJgCdNSacgcO9xz34mOy6qP9lY0fbNlJqq7TdtSqmKSn/TBjeWGanL/zVpjLQ9IvVT/Yx5Ngr3PRmY+lZydusyzDtrTNQ1kiSKa84xlNVCKPzY/Fedj2vhWVM4a+0MeXbJFrCYAdgm7S69B/TmjA1u3PlQcMPmFn3l0wKQ9ex2Pqz34+o4Yyp+B5pFg11tgATnzwLPS9Ukd6XjJe+MFZU2/b7s2lX3JjmqrrPt7qxWQEo2mgVDPZyt1a3ya1kkcqm6tlxI8bC6FtRdKh5sBWTExjXvRdXbJmr7kV51zat7R1SKQCoemPMK72uxPu3bYpydMu7adMacJH3qnNPGtvVisU5It3M2saIckhEpBTcsPizu03o9696iTKp7RfovtgIS3+HJM4av6BGyYEqv1t1zzbVj3uBz7tlRB+4/4Z5L1lKzCCQ2TalwchdGlWTBG743Vp2ftAFOtAGBOtNbZEqbd4pAoiUP2IT2elRXNDpTeKF1IuXsSdDXCkjyop037aRTALlEw3zQVG9JHv646jdadb0DkKZdutEKSLpt1w4YTDO7ZNMzc1tqIiK/eH80zGFa39ypb1+S0h16//BZcD2/Boq378/Au24MIOkv5a7/WzuQiHz6SxpAfnX8p7fIjghVII2wbT1qDwBIPMTSf6N/BfgHi1YQplUrVPoAAAAASUVORK5CYII="
              />
            </svg>
          </div>
          <div class="content">
            <p class="tf-color">{{ $t("phone_call_us") }}</p>
            <p class="number-phone">{{ contact.phone }}</p>
          </div>
        </div>
        <div class="button-right">
          <router-link
            to="/franchise"
            class="button-default"
            style="text-transform: uppercase"
            >{{ $t("franchise") }}</router-link
          >
        </div>
      </div>
    </div>
    <div class="header-inner">
      <div class="header-inner-wrap">
        <div class="flex">
          <div id="site-logo">
            <div class="site-logo-wrap">
              <router-link to="/" class="main-logo">
                <img
                  id="logo_header"
                  alt=""
                  loading="lazy"
                  :src="getImageUrl(contact.logo)"
              /></router-link>
            </div>
          </div>
          <!-- /logo -->
          <div class="header-left">
            <div class="canvas">
              <div class="canvas-button"><span></span></div>
              <div class="wg-welcom">
                <div class="inner">
                  <div class="button-close"><i class="icon-close"></i></div>
                  <img
                    style="max-width: 35%"
                    :src="getImageUrl(contact.logo)"
                    alt=""
                  />
                  <div class="text">
                    {{ contact.small_description }}
                  </div>
                  <div class="number-phone">{{ contact.phone }}</div>
                  <div class="text line-under">
                    {{ contact.address }} <br />
                    {{ contact.shop_email }}
                  </div>
                  <div class="text line-under">
                    {{ $t("opening_hours") }}: <br />
                    {{ $t("monday") }} - {{ $t("sunday") }} :
                    {{ openHour.open_time_hours_from }} -
                    {{ openHour.open_time_hours_to }}, Delivery :
                    {{ openHour.delivery_time_from }} -
                    {{ openHour.delivery_time_to }}
                  </div>
                  <div class="widget-social justify-center">
                    <ul class="">
                      <li v-if="contact.facebook != null">
                        <a
                          :href="contact.facebook"
                          target="_blank"
                          class="icon-fb"
                        ></a>
                      </li>
                      <li v-if="contact.linkedIn != null">
                        <a :href="contact.linkedIn" target="_blank"
                          ><i class="fa-brands fa-square-linkedin"></i
                        ></a>
                      </li>
                      <li v-if="contact.instagram != null">
                        <a
                          :href="contact.instagram"
                          class="icon-instagram2"
                          target="_blank"
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <nav class="main-nav">
          <ul class="menu-primary-menu">
            <li
              class="menu-item"
              :class="{ 'current-menu-item': $route.path === '/' }"
            >
              <router-link to="/">{{ $t("home") }}</router-link>
            </li>
            <li
              class="menu-item"
              :class="{ 'current-menu-item': $route.path === '/menu' }"
            >
              <router-link to="/menu">{{ $t("menu") }}</router-link>
            </li>
            <li
              class="menu-item"
              :class="{ 'current-menu-item': $route.path === '/contact' }"
            >
              <router-link to="/contact">{{ $t("contact") }}</router-link>
            </li>
          </ul>
        </nav>
        <!-- /main-nav -->
        <div class="header-right type-1">
          <div class="header-language">
            <span class="dropdown" id="select-language">
              <span class="btn-selector select">
                <span>{{ selectedLangLabel }}</span>
              </span>

              <ul>
                <li @click="changeLanguage('en')">
                  <span>English</span>
                </li>
                <li @click="changeLanguage('gr')">
                  <span>Greek</span>
                </li>
              </ul>
            </span>
          </div>
          <div class="mobile-button">
            <span></span>
          </div>
        </div>
        <!-- /header-right -->
      </div>
    </div>

    <div class="mobile-nav-wrap">
      <div class="overlay-mobile-nav"></div>
      <div class="inner-mobile-nav">
        <div class="relative">
          <router-link class="main-logo" to="/">
            <img
              id="mobile-logo_header"
              alt=""
              loading="lazy"
              :src="getImageUrl(contact.logo)"
            />
          </router-link>
          <div class="mobile-nav-close">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              fill="white"
              x="0px"
              y="0px"
              width="20px"
              height="20px"
              viewBox="0 0 122.878 122.88"
              enable-background="new 0 0 122.878 122.88"
              xml:space="preserve"
            >
              <g>
                <path
                  d="M1.426,8.313c-1.901-1.901-1.901-4.984,0-6.886c1.901-1.902,4.984-1.902,6.886,0l53.127,53.127l53.127-53.127 c1.901-1.902,4.984-1.902,6.887,0c1.901,1.901,1.901,4.985,0,6.886L68.324,61.439l53.128,53.128c1.901,1.901,1.901,4.984,0,6.886 c-1.902,1.902-4.985,1.902-6.887,0L61.438,68.326L8.312,121.453c-1.901,1.902-4.984,1.902-6.886,0 c-1.901-1.901-1.901-4.984,0-6.886l53.127-53.128L1.426,8.313L1.426,8.313z"
                />
              </g>
            </svg>
          </div>
        </div>
        <nav id="mobile-main-nav" class="mobile-main-nav">
          <ul id="menu-mobile-menu" class="menu">
            <li
              class="menu-item"
              :class="{ 'current-menu-item': $route.path === '/' }"
            >
              <router-link to="/">{{ $t("home") }}</router-link>
            </li>
            <li
              class="menu-item"
              :class="{ 'current-menu-item': $route.path === '/menu' }"
            >
              <router-link to="/menu">{{ $t("menu") }}</router-link>
            </li>
            <li
              class="menu-item"
              :class="{ 'current-menu-item': $route.path === '/contact' }"
            >
              <router-link to="/contact">{{ $t("contact") }}</router-link>
            </li>
            <li
              class="button-left"
              style="text-transform: uppercase"
              :class="{ '': $route.path === '/franchise' }"
            >
              <router-link class="button-default" to="/franchise">{{
                $t("franchise")
              }}</router-link>
            </li>
            <li class="menu-item">
              <div class="header-language" style="display: block !important">
                <span class="dropdown" id="select-language">
                  <span
                    class="btn-selector select"
                    @click.stop="isLangOpen = !isLangOpen"
                  >
                    <span>{{ selectedLangLabel }}</span>
                  </span>

                  <ul v-show="isLangOpen" style="left: 72%">
                    <li
                      style="background-color: #1f5f73 !important"
                      @click="changeLanguage('en')"
                    >
                      <span>English</span>
                    </li>
                    <li
                      style="background-color: #1f5f73 !important"
                      @click="changeLanguage('gr')"
                    >
                      <span>Greek</span>
                    </li>
                  </ul>
                </span>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import { langStore } from "../../../langStore";
import axios from "axios";

export default {
  name: "HeaderComponent",
  data() {
    return {
      langStore,
      contact: {},
      openHour: {},
      isLangOpen: false,
    };
  },

  computed: {
    selectedLangLabel() {
      return this.langStore.lang === "en" ? "English" : "Greek";
    },
  },

  watch: {
    "langStore.lang"() {
      this.fetchData();
    },

    "$route.fullPath"() {
      if (window.innerWidth < 992) {
        this.$nextTick(() => {
          this.forceCloseMobileMenu();

          if (window.initHeader) {
            window.initHeader();
          }
        });
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        if (window.initHeader) {
          window.initHeader();
        }
      }, 0);
    });
    this.fetchData();
  },

  methods: {
    fetchData() {
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/api/setting`, {
          params: { lang: this.langStore.lang },
        })
        .then((response) => {
          this.contact = response.data;
        })
        .catch((error) => {
          console.error("There was an error fetching the data:", error);
        });

      axios
        .get(`${process.env.VUE_APP_BASE_URL}/api/open-hour`)
        .then((response) => {
          this.openHour = response.data;
        })
        .catch((error) => {
          console.error("There was an error fetching the data:", error);
        });
    },

    forceCloseMobileMenu() {
      const menu = document.querySelector(".mobile-nav-wrap");
      const body = document.body;

      if (!menu) return;

      menu.classList.remove("open", "active");
      body.classList.remove("mobile-menu-open", "overflow-hidden");
    },

    changeLanguage(lang) {
      this.$i18n.locale = lang;
      this.langStore.lang = lang;
      this.isLangOpen = false;
    },
    
    getImageUrl(photo) {
      const baseUrl = `${process.env.VUE_APP_BASE_URL}/uploads/`;
      return baseUrl + photo;
    },
  },
};
</script>

<style>
.header-fixed {
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}
</style>
